import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { PositionedOverlay, Image, Ribbon } from 'reaxl';
import { useFeatures } from '@atc/features';

/**
 *   Molecule to encapsulate standard PositionOverlay + Ribbon + kbb Image logic
 *
 */
function KBBDealIndicator(_ref) {
  let {
    lazyLoad = true,
    flat = false,
    className,
    pricingDetail,
    position = 'topRight',
    logoSize = 'default'
  } = _ref;
  const {
    kbb_price_rating: [enableKBBDealIndicator]
  } = useFeatures(['kbb_price_rating']);
  const kbbLogo = {
    alt: 'KBB.com Price Advisor',
    src: 'https://www.autotrader.com/content/dam/autotrader/additionalresources/kbb_logo.svg'
  };
  const {
    dealIndicator
  } = pricingDetail;
  const positionLeft = position === 'topLeft';
  const invertPosition = positionLeft ? 'topRight' : 'topLeft';
  const isSmallLogo = logoSize === 'small';
  const ribbonProps = dealIndicator && {
    position: positionLeft ? 'left' : 'right',
    label: `${dealIndicator.toUpperCase()} PRICE`,
    uiContext: `${dealIndicator.toLowerCase()}-price`
  };
  const styles = {
    [positionLeft ? 'left' : 'right']: '17px'
  };
  const renderKBBImage = () => {
    const imageClass = positionLeft ? 'order-1' : 'order-2';
    return /*#__PURE__*/React.createElement(Image, Object.assign({
      className: clsx('media-gallery-viewer', imageClass),
      style: styles,
      lazyload: lazyLoad,
      height: 34,
      width: 25
    }, kbbLogo));
  };
  const flatClasses = clsx('padding-left-1 text-bold', {
    'padding-top-1 text-size-200': !isSmallLogo,
    'text-size-300': isSmallLogo,
    'text-success': dealIndicator && dealIndicator.toUpperCase() === 'GREAT',
    'text-subdued-lighter': dealIndicator && dealIndicator.toUpperCase() === 'GOOD'
  });
  if (!enableKBBDealIndicator) {
    return null;
  }
  return !flat ? /*#__PURE__*/_jsx(PositionedOverlay, {
    className: clsx('display-flex', className),
    shrinkwrap: false
  }, void 0, /*#__PURE__*/_jsx(PositionedOverlay.Base, {}, void 0, /*#__PURE__*/React.createElement(Ribbon, Object.assign({
    className: clsx('text-size-200 margin-vertical-1', {
      'padding-left-3': !positionLeft,
      'padding-right-3': positionLeft,
      flat
    })
  }, ribbonProps))), /*#__PURE__*/_jsx(PositionedOverlay.Anchor, {
    position: invertPosition,
    offsetTop: 0
  }, void 0, renderKBBImage())) : /*#__PURE__*/_jsx("div", {
    className: clsx('display-flex flex-nowrap', className, {
      'align-items-center': isSmallLogo
    }),
    "data-cmp": "KBBDealIndicator"
  }, void 0, /*#__PURE__*/React.createElement(Image, Object.assign({
    key: "KBBDealIndicator-image",
    style: styles,
    lazyload: lazyLoad,
    height: isSmallLogo ? 20 : 24,
    width: 18
  }, kbbLogo)), /*#__PURE__*/_jsx("span", {
    className: flatClasses
  }, void 0, dealIndicator.toUpperCase(), ' ', "PRICE"));
}
export default KBBDealIndicator;